import { render } from "./LoyaltyFeature.vue?vue&type=template&id=0cceddb9&scoped=true"
import script from "./LoyaltyFeature.vue?vue&type=script&lang=js"
export * from "./LoyaltyFeature.vue?vue&type=script&lang=js"

import "./LoyaltyFeature.vue?vue&type=style&index=0&id=0cceddb9&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cceddb9"]])

export default __exports__